import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import ProgramDetail from "./pages/ProgramDetail";
import Videos from "./pages/Videos";
import VideoDetail from "./pages/VideoDetail";
import Live from "./pages/Live";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminPrograms from "./pages/admin/AdminPrograms";
import AdminVideos from "./pages/admin/AdminVideos";
import AdminLive from "./pages/admin/AdminLive";
import AdminLayout from "./components/admin/AdminLayout";
import AdminGuard from "./components/admin/AdminGuard";
import DocumentTitle from "./components/DocumentTitle";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicShell() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[var(--tv-bg)]">
      <BrowserRouter>
        <DocumentTitle />
        <ScrollToTop />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <AdminGuard>
                <AdminLayout />
              </AdminGuard>
            }
          >
            <Route index element={<Navigate to="/admin/programs" replace />} />
            <Route path="programs" element={<AdminPrograms />} />
            <Route path="videos" element={<AdminVideos />} />
            <Route path="live" element={<AdminLive />} />
          </Route>
          <Route element={<PublicShell />}>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/programlar" element={<Programs />} />
            <Route path="/programlar/:slug" element={<ProgramDetail />} />
            <Route path="/videolar" element={<Videos />} />
            <Route path="/videolar/:id" element={<VideoDetail />} />
            <Route path="/canli-yayin" element={<Live />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/sss" element={<Faq />} />
            <Route path="/kullanim-kosullari" element={<Terms />} />
            <Route path="/gizlilik-politikasi" element={<Privacy />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
